import {
  USER_ROLE_ADMIN,
  USER_ROLE_DOCTOR,
  USER_ROLE_NURSE
} from '../../constants';
import BaseVoter from './base';

class QuestionnaireVoter extends BaseVoter {
  /**
   * @param User user
   * @returns {boolean}
   */
  canView (user) {
    return this.isUser(user);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canEdit (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_NURSE]);
  }

  /**
   * @param User user
   * @returns {boolean}
   */
  canComment (user) {
    return this.userHasOneRole(user, [USER_ROLE_ADMIN, USER_ROLE_DOCTOR]);
  }
}

export default new QuestionnaireVoter();
